// extracted by mini-css-extract-plugin
export default {"agent-select":"styles_agent-select__IftUZ"};